import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { TabHandlerService } from '../../../services/tab-handler.service';
import { CrmDocumentType } from '../../../shared/constants/enums';
import { ViewFile } from '../../../shared/view-file/view-file.interface';
import { Popover } from 'primeng/popover';
import { FormField } from '../../../shared/form-field/form-field';
import { ServiceOrderDataService } from '../service-order-data.service';

@Component({
  standalone: false,
  selector: 'service-attacments',
  templateUrl: 'service-attachments.template.html',
})
export class ServiceAttachmentsComponent implements OnInit, OnDestroy {
  documentSearchParams: ViewFile;
  tabKey: string;
  displayAdd: boolean;
  displayVerify: boolean;
  header: string;
  formModalInfo: FormField<any>[] = [];
  selectedItem: any;
  private querySubscriptions: Subscription[] = [];

  constructor(
    private serviceOrderDataService: ServiceOrderDataService,
    private tabHandlerService: TabHandlerService,
  ) {
    this.displayAdd = false;
    this.displayVerify = false;
    this.documentSearchParams = {
      fileName: '',
      attachmentsType: { key: 'ClaimContact', value: CrmDocumentType.ClaimContact },
      uploadedDate: null,
      offset: 0,
      limit: 20,
      identifierId: null,
    };
  }

  ngOnInit() {
    this.syncDocumentSearchParams();

    this.querySubscriptions.push(
      this.tabHandlerService.selectedTab.subscribe({
        next: (tab) => {
          if (this.tabKey === tab) {
            this.syncDocumentSearchParams();
          }
        },
      }),
    );

    this.querySubscriptions.push(
      this.serviceOrderDataService.isClaimDataAvailable.subscribe({
        next: (isClaimDataAvailable) => {
          if (isClaimDataAvailable) {
            this.syncDocumentSearchParams();
          }
        },
      }),
    );

    this.querySubscriptions.push(
      this.serviceOrderDataService.newClaimsId.subscribe({
        next: (newClaimsId) => {
          if (newClaimsId && newClaimsId !== 0) {
            this.syncDocumentSearchParams();
          }
        },
      }),
    );
  }

  ngOnDestroy() {
    this.querySubscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  private syncDocumentSearchParams(): void {
    const claimId = this.resolveClaimId();
    if (!claimId) {
      return;
    }

    const normalizedClaimId = parseInt(String(claimId), 10);
    if (
      this.documentSearchParams.identifierId === normalizedClaimId &&
      this.documentSearchParams.attachmentsType?.value === CrmDocumentType.ClaimContact
    ) {
      return;
    }

    this.documentSearchParams = {
      ...this.documentSearchParams,
      identifierId: normalizedClaimId,
    };
  }

  private resolveClaimId(): number | null {
    const claimData = this.serviceOrderDataService.serviceOrderDataModel.claimData;
    if (claimData?.claimIdOriginal) {
      return claimData.claimIdOriginal;
    }

    const claimId = this.serviceOrderDataService.serviceConfig.searchParams.claimId;
    return claimId ? parseInt(String(claimId), 10) : null;
  }
}
